import DocViewShell from "@/components/DocViewShell";
import CongruenceBlueprint from "@/components/blueprints/CongruenceBlueprint";

export default function CongruenceView() {
  return (
    <DocViewShell
      eyebrow="Nadler-Tushman Congruence"
      eyebrowClass="text-emerald-700"
      toolName="Nadler-Tushman Congruence"
      editPathFn={(id) => `/congruence/${id}`}
      render={(doc) => <CongruenceBlueprint doc={doc} />}
    />
  );
}
